import PagesContainerComponent from '@wix/thunderbolt-elements/src/components/PagesContainer/viewer/PagesContainer';
import MasterPageComponent from '@wix/thunderbolt-elements/src/thunderbolt-core-components/MasterPage/viewer/MasterPage';


const PagesContainer = {
  component: PagesContainerComponent
};

const MasterPage = {
  component: MasterPageComponent
};


export const components = {
  ['PagesContainer']: PagesContainer,
  ['MasterPage']: MasterPage
};

